import { supabase } from '../lib/supabase'

/**
 * Registro de suscripciones Web Push del navegador.
 * Tabla: Tickets.pushSubscription (una fila por navegador/dispositivo, clave: endpoint).
 * @namespace pushSubscriptionService
 */
const pushSubscriptionService = {
  schemaName: 'Tickets',
  tableName: 'pushSubscription',

  /**
   * Registra (o actualiza) la suscripción push actual para el usuario.
   * @param {Object} row - { userId, endpoint, p256dh, auth, userAgent }
   */
  async upsert(row) {
    try {
      const { error } = await supabase
        .schema(this.schemaName)
        .from(this.tableName)
        .upsert(row, { onConflict: 'endpoint' })
      if (error) throw error
      return { success: true }
    } catch (error) {
      console.error('Error saving push subscription:', error)
      return { success: false, error: error.message }
    }
  },

  /**
   * Elimina una suscripción por su endpoint.
   * @param {string} endpoint
   */
  async removeByEndpoint(endpoint) {
    try {
      const { error } = await supabase
        .schema(this.schemaName)
        .from(this.tableName)
        .delete()
        .eq('endpoint', endpoint)
      if (error) throw error
      return { success: true }
    } catch (error) {
      console.error('Error deleting push subscription:', error)
      return { success: false, error: error.message }
    }
  },
}

export default pushSubscriptionService
